import React from 'react';
import styled from 'styled-components';

import { LineBackground } from './LineBackground';
import { LineForeground } from './LineForeground';
import { Node } from './Node';
import { NodeContainer } from './NodeContainer';

import { spacing } from '../../constants';

interface IProps {
    className?: string;
    step: number;
    totalSteps: number;
    backgroundGrey?: boolean;
    isMobile?: boolean;
}

const BaseStepCounter: React.FC<IProps> = ({
    className,
    step,
    totalSteps,
    isMobile,
    backgroundGrey,
}) => {
    const foreGroundLineWidth = (100 / (totalSteps - 1)) * (step - 1);

    return (
        <div className={className}>
            <LineBackground backgroundGrey={backgroundGrey} />
            <LineForeground width={foreGroundLineWidth} />

            <NodeContainer isMobile={isMobile}>
                {Array.from({ length: totalSteps }).map((el, index) => {
                    const nodePassed = step >= index + 1;
                    const nodeActive = step === index + 1;

                    return (
                        <div key={index}>
                            <Node
                                passed={nodePassed}
                                active={nodeActive}
                                backgroundGrey={backgroundGrey}
                            />
                        </div>
                    );
                })}
            </NodeContainer>
        </div>
    );
};

export const StepCounter = styled(BaseStepCounter)`
    width: 100%;
    max-width: 300px;
    position: relative;
    margin: 0 ${spacing.md};
`;
